__turbopack_context__.v({
  "avocado": "gradientMask-module-scss-module__tnwGKq__avocado",
  "black": "gradientMask-module-scss-module__tnwGKq__black",
  "cardinal": "gradientMask-module-scss-module__tnwGKq__cardinal",
  "denim": "gradientMask-module-scss-module__tnwGKq__denim",
  "gradientMask": "gradientMask-module-scss-module__tnwGKq__gradientMask",
  "green": "gradientMask-module-scss-module__tnwGKq__green",
  "left": "gradientMask-module-scss-module__tnwGKq__left",
  "linear": "gradientMask-module-scss-module__tnwGKq__linear",
  "radial": "gradientMask-module-scss-module__tnwGKq__radial",
  "right": "gradientMask-module-scss-module__tnwGKq__right",
  "sapphire": "gradientMask-module-scss-module__tnwGKq__sapphire",
  "sky": "gradientMask-module-scss-module__tnwGKq__sky",
  "stainless": "gradientMask-module-scss-module__tnwGKq__stainless",
  "white": "gradientMask-module-scss-module__tnwGKq__white",
});
